
export default function Hero() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 41, 59, 0.8), rgba(71, 85, 105, 0.7)), url('https://public.readdy.ai/ai/img_res/2e00e6bc911428490304fd79b9d51d5c.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center text-white">
          <div className="mb-8">
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 inline-block shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/51a88c584cf88c9ad8e9758347b3e63d/9cb24b4a8cea094c3122fabfd7fc0522.png" 
                alt="SGBS - Strategic Global Business Solutions" 
                className="h-80 lg:h-96 mx-auto"
              />
            </div>
          </div>
          <h2 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight">
            Precision Engineering for
            <span className="block text-orange-500">Specialty Facilities</span>
          </h2>
          <p className="text-xl lg:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed text-gray-200">
            Expert construction project management, HVAC installation, and custom solutions for unique facility needs. Delivering technical excellence with industrial precision.
          </p>
          <div className="flex justify-center">
            <button 
              onClick={scrollToContact}
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Start Your Project
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
